import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc';
import { urlApiFactory } from '../model/factory';

export const PATHNAME = '/v2/core/ComponentVersions';

export const schema = manageSchema
  .pick({
    hostApi: true
  })
  .required();

export const fetchGet = (params) => async () => {
  const prms = schema.parse(params);
  const url = urlApiFactory(prms);
  url.pathname = PATHNAME;

  const req = new Request(url);
  return fetch(req).then(assertOk).then(takeData);
};
